import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  ViewChild,
  ViewContainerRef,
  ComponentRef,
  Injector, Compiler, ChangeDetectorRef
} from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { SEOService } from '../../shared/services/seo.service';
import { CmsService } from '../../cms/services/cms.service';

@Component({
  selector: 'custom-page',
  templateUrl: './custom-page.component.html',
  styleUrls: ['./custom-page.component.scss']
})
export class CustomPageComponent implements OnInit, OnDestroy {
  private unsubscribe$ = new Subject;

  public page = null;
  public isLoaded: boolean = false;
  @Input() pageId: number;
  @Input() networkId: number;
  @ViewChild('dynamicContainer', { read: ViewContainerRef }) dynamicContainer: ViewContainerRef;
  componentRef: ComponentRef<any>;

  public showContactsLink: boolean = false;
  public siteUrl: string;
  public isIstitutionalWebsite: boolean = false;
  public isConadRoute: boolean;
  private timeoutIDs: ReturnType<typeof setTimeout>[] = [];

  constructor(
    private _router: Router,
    private _route: ActivatedRoute,
    private _seoService: SEOService,
    private _cmsService: CmsService,
    private _injector: Injector,
    private _compiler: Compiler,
    private changeDetector : ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this._route.paramMap.pipe(takeUntil(this.unsubscribe$)).subscribe(params => {
      this._cmsService.hasCmsEnabled$.pipe(takeUntil(this.unsubscribe$)).subscribe(isEnabled => {
        if (this._route.snapshot.data.cmsPath == 'landing-page') {
          if (this.pageId && this.networkId) {
            this.getPageById(this.pageId, this.networkId);
          } else {
          }
        } else if (isEnabled == true) {
          this.getPage(params, 3);
        }
      });
    });
    this._cmsService.siteUrl$.pipe(takeUntil(this.unsubscribe$)).subscribe(url => {
      this.isIstitutionalWebsite = ['www.geotn.it','www.vacanzewelcometravel.it'].indexOf(url) >= 0;
      this.isConadRoute = window.location.href.includes('/conad');
    })
  }


  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    this.timeoutIDs.forEach(id => clearTimeout(id));
  }

  private getPage(params, retry) {
    if (retry == 0) {
      this._router.navigate([""]);
    } else {
      const allpages = this._cmsService.getPages();
      if (allpages) {
        let cPage;
        const titleParam = params.get('title');
        if (titleParam != undefined) {
          cPage = allpages.find(x => x.path == params.get('title') && x.type.basePath == this._route.snapshot.data.cmsPath);
          if (this._route.snapshot.data.cmsPath == 'le-nostre-proposte/') this.showContactsLink = true;
        } else {
          cPage = allpages.find(x => x.path == this._route.snapshot.data.cmsPath.slice(0, -1));
        }

        this.getPageById(cPage.id);

      } else {
        this.timeoutIDs.push(setTimeout(() => {
          retry--;
          this.getPage(params, retry);
        }, 450))
      }
    }
  }

  public getPageById(id: number, network?: number): void {
    this._cmsService.getPageById(id, network).pipe(takeUntil(this.unsubscribe$)).subscribe(customPage => {
      this.page = customPage;
      if(this.isIstitutionalWebsite){
        this._loadStoreLocatorComponent();
      }
      this.setSeoData(customPage.title, customPage.image, this._cmsService.stripHtml(customPage.shortDescription));
      this.isLoaded = true;
    })
  }

  private setSeoData(title: string, image: string, description: string): void {
    this._seoService.setTitle(title);
    this._seoService.setImage(image);
    this._seoService.setDescription(description);
  }

  // TODO REFACTOR? provando a importare il modulo StoreLocatorPageModule nel relavito custom-page.module il componente sovrascriveva l'attuale anche senza selettore, attualmente questo Workaround funziona.
  private _loadStoreLocatorComponent() {
    import('../store-locator-page/store-locator-page.module').then(({ StoreLocatorPageModule }) => {
      this._compiler.compileModuleAsync(StoreLocatorPageModule).then(moduleFactory => {
        const moduleRef = moduleFactory.create(this._injector);
        const storeLocatorComponentFactory = moduleRef.componentFactoryResolver.resolveComponentFactory(StoreLocatorPageModule.getComponent());
        this.changeDetector.detectChanges();
        this.dynamicContainer.clear();
        this.componentRef = this.dynamicContainer.createComponent(storeLocatorComponentFactory);
      });
    });
  }

}
